var map = {
	"./ai/years.json": 3948,
	"./android/years.json": 3652,
	"./arvr/years.json": 5878,
	"./backend/years.json": 9479,
	"./biotech/years.json": 6895,
	"./blockchain/years.json": 3656,
	"./creativedesign/years.json": 3438,
	"./cybersecurity/years.json": 8594,
	"./devops/years.json": 5335,
	"./embedded-system/years.json": 6219,
	"./foss/years.json": 5825,
	"./frontend/years.json": 9196,
	"./ios/years.json": 2666,
	"./iot/years.json": 7023,
	"./marketing/years.json": 674,
	"./pm/years.json": 9257,
	"./qa/years.json": 4742,
	"./quantum-computing/years.json": 1523,
	"./robotics-automation/years.json": 7970,
	"./uiux/years.json": 2980,
	"./web/years.json": 4237
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 187;
module.exports = webpackAsyncContext;